import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero, Reveal } from "@/components/Primitives";
import ProofStrip from "@/components/ProofStrip";
import { HOW_IT_WORKS, BUSINESS } from "@/data/site";

export default function HowItWorks() {
  return (
    <>
      <Seo
        title="How It Works"
        description="How booking a trusted DFW sitter works with Mom's Best Friend — tell us what you need, we match a screened caregiver, confirm the details, and you enjoy trusted care."
        breadcrumbs={[{ name: "Home", item: "/" }, { name: "How It Works", item: "/how-it-works" }]}
      />
      <PageHero
        overline="How it works"
        title="Trusted care, made simple"
        subtitle="No apps to wrestle with, no anonymous strangers. Just a real person matching your family with a caregiver you can trust."
      />
      <ProofStrip />

      <section className="container-mbf py-20 md:py-28">
        <div className="max-w-3xl mx-auto">
          {HOW_IT_WORKS.map((step, i) => (
            <Reveal key={step.n} delay={i * 0.05}>
              <div className="flex gap-6 pb-12 last:pb-0 relative" data-testid={`howitworks-step-${step.n}`}>
                {i < HOW_IT_WORKS.length - 1 && <span className="absolute left-[27px] top-16 bottom-0 w-px bg-[#F1E6D0]" />}
                <div className="w-14 h-14 rounded-full bg-espresso text-parchment font-serif text-xl flex items-center justify-center shrink-0 z-10">{step.n}</div>
                <div className="pt-2">
                  <h3 className="font-serif text-xl md:text-2xl text-espresso mb-2">{step.title}</h3>
                  <p className="text-base text-stoneish leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-8 max-w-3xl mx-auto bg-parchment-2 rounded-2xl border border-[#F1E6D0] p-8 md:p-10 text-center">
          <h3 className="font-serif text-2xl text-espresso mb-3">Need care after hours or last minute?</h3>
          <p className="text-sm text-stoneish mb-6 max-w-lg mx-auto">Submit a request any time — if it's outside office hours we'll follow up first thing. For urgent needs, call us directly.</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/book" className="btn-accent" data-testid="howitworks-request-cta">Start a request <ArrowRight className="w-4 h-4" /></Link>
            <a href={BUSINESS.phoneHref} className="btn-outline" data-testid="howitworks-phone-link"><Phone className="w-4 h-4" /> {BUSINESS.phone}</a>
          </div>
        </div>
      </section>
    </>
  );
}
